import { css } from 'styled-components';
export const BKJThemeChip = {
    Purple: css `
    background-color: ${({ theme }) => theme.colors.PrimaryDefault};
  `,
    Red: css `
    background-color: ${({ theme }) => theme.colors.ErrorDefault};
  `,
};
//# sourceMappingURL=BKJChip.theme.js.map